// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet-portrait-up":"576","_statusIcon":"Lieferungsansicht__statusIcon__2M7yz"};